import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames/bind';

import Illustration from 'foundations/Illustrations/Illustration';
import Icon from 'foundations/Icons/Icon';
import CopyToClipboard from '@components/CopyToClipboard/CopyToClipboard';
import Tooltip from 'elements/Tooltip/Tooltip';
import { ListElement } from 'elements/Tooltip/Layout';

import styles from './IllustrationCard.css';

const IllustrationCard = ({ name, type, size, width, height }) => {
  const cx = classnames.bind(styles);

  return (
    <li className={cx('wrapper', `card-${type}`)}>
      <CopyToClipboard
        dataText={
          width || height
            ? `<Illustration name={'${name}'} height={'${height}'} width={'${width}'} />`
            : `<Illustration name={'${name}'} size={'${type}'} />`
        }
        render={
          (copied) => {
            return (
              <div className={cx('preview', { 'active': copied })}>
                <div className={styles.illustration}>
                  <Illustration
                    name={name}
                    size={type}
                    customClasses={styles.svg}
                    width={width}
                    height={height}
                  />
                  <Tooltip
                    target={
                      <Icon
                        icon={copied ? 'confirmation' : 'duplicate'}
                        type={'20'}
                        customClasses={cx('copyIcon', { 'active': copied })} />
                    }
                    open={copied}
                    placement={'top'}
                  >
                    <ListElement>Illustration Copied!</ListElement>
                  </Tooltip>
                </div>
              </div>
            );
          }
        }
      />
      <div className={styles.details}>
        <p className={classnames(styles.name, 'small')}>{name}</p>
        <p className={classnames(styles.size, 'tag')}>{size}</p>
      </div>
    </li>
  );
};

IllustrationCard.propTypes = {
  name: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
  size: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
};

export default IllustrationCard;



// WEBPACK FOOTER //
// ./src/containers/foundations/Illustrations/IllustrationCard/IllustrationCard.js